import { render } from "./CdesMainUi.vue?vue&type=template&id=3e2db5e6&ts=true"
import script from "./CdesMainUi.ts?vue&type=script&lang=ts&external"
export * from "./CdesMainUi.ts?vue&type=script&lang=ts&external"

import "./CdesMainUi.vue?vue&type=style&index=0&id=3e2db5e6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__